// extracted by mini-css-extract-plugin
export default {"Container":"MiddleContainer_Container__fgmlI"};